<div class="subscription">
    <h2 class="mat-headline-6 mb-0 d-flex">
        AutoPay feature
        <mat-icon
            [matTooltip]="information"
            matTooltipPosition="after"
            class="md-icon-18 align-self-center"
            color="primary"
        >
            info
        </mat-icon>
    </h2>
    <form [formGroup]="autoPayForm">
        <mat-checkbox class="mat-small mb-3" formControlName="isSelected" (change)="activeAutoPay($event.checked)">
            If eligible, I consent to the use of my Maximum Balance Limit to cover the MAWB identified above.
        </mat-checkbox>
        @if (showEmail) {
            @if (isAuthenticated) {
                <mat-form-field class="col-12 mb-0">
                    <mat-label for="email" class="label-lg text-nowrap"> Notification email </mat-label>
                    <input
                        matInput
                        type="email"
                        formControlName="email"
                        placeholder="user@gmail.com"
                        (keyup)="onKeyEmail()"
                        id="email-autopay"
                    />
                    <mat-error>
                        <app-field-error [field]="'email'" [messageList]="formErrors['email']" />
                    </mat-error>
                </mat-form-field>
                @if (showNotes) {
                    <span class="mat-body-2 notes">
                        Note: When you enable the AutoPay feature, please note that the same email notifications for the
                        Master Air Waybill (MAWB) subscription will be sent out.
                    </span>
                }
                @if (!isAccountOnHold) {
                    <div class="mt-3">
                        <app-auto-pay-customer-reference />
                    </div>
                }
                @if (!isRequestor) {
                    <app-auto-pay-cargo-credit />
                }
                @if (isAccountOnHold) {
                    <div class="my-2">
                        <app-account-on-hold-simple />
                    </div>
                }
            } @else {
                <div class="my-3 w-75">
                    <app-auto-pay-login />
                </div>
            }
        }
    </form>
</div>
